<div class="org-info-section">
  <div>
    <div class="title">Organization Info</div>
    <form [formRoot]="orgNameField">
      <div class="input-container">
        <div>
          <label for="orgName" [class.red]="orgNameErrorShown()"> Organization Name </label>
          @if (orgNameErrorShown() && orgNameRequired()) {
            <span class="red"> is required</span>
          }
        </div>
        <div class="flex items-center gap-[8px]">
          @if (!editMode()) {
            <div
              class="max-w-[430px] h-[52px] leading-[52px] mx-[23px] text-[16px] text-[#5a5a5a] border border-solid border-transparent rounded-[26px]"
              gnxTextOverflowEllipsis
              #orgName="gnxTextOverflowEllipsis"
              [matTooltip]="orgName.tooltipText"
              [matTooltipDisabled]="!orgName.isOverflowed"
              matTooltipClass="blue-md-tooltip"
            >
              {{ data().organization.name }}
            </div>
            <div
              matTooltip="Permission required for this action"
              [matTooltipDisabled]="isAdmin()"
              matTooltipClass="blue-md-tooltip wide"
            >
              <button type="button" class="edit-btn" [disabled]="!isAdmin()" (click)="isAdmin() && onEdit()">
                Edit
              </button>
            </div>
          } @else {
            <input
              id="orgName"
              [formField]="orgNameField"
              placeholder="Name"
              (keydown.enter)="onSaveWithConfirmation()"
              class="w-[430px] h-[52px] px-[23px] text-[16px] flex items-center border border-solid border-[#e5e7eb] rounded-[26px] bg-white outline-none placeholder:text-[#999999]"
              [class]="{
                'border-red-500': orgNameField().dirty() && orgNameField().invalid(),
                'border-[#d5d7db]': !(orgNameField().dirty() && orgNameField().invalid()),
              }"
            />
            <button type="button" class="cancel-btn" (click)="onCancelEdit()">Cancel</button>
            <button
              type="button"
              class="save-btn"
              [disabled]="!orgNameField().dirty() || orgNameField().invalid() || auth0Store.updateOrgInProgress()"
              (click)="onSaveWithConfirmation()"
            >
              @if (auth0Store.updateOrgInProgress()) {
                <gnx-dots-loader />
              } @else {
                Save
              }
            </button>
          }
        </div>
        @if (orgNameErrorShown() && orgNameTaken(); as taken) {
          <span class="red note-msg">{{ taken.message }}</span>
        }
      </div>
    </form>
  </div>
</div>
